import { RefObject } from "react";
import { AgGridReact } from "ag-grid-react";
import { useDetailTableHandlers as useCommonDetailTableHandlers } from "src/hooks/useDetailTableHandlers";
import { useCodeSearch } from "src/hooks/useCodeSearch";
import { createModuleConfig } from "src/utils/detail-table/detailTableUtils";
import { calculateDetailAmount } from "src/utils/calculation/calculationUtils";
import { WMS1130_R01DetailDto } from "../Dto_WMS1130_R01";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";
interface UseWMS1130_R01CellChangeProps {
	WMS1130_R01DetailList: WMS1130_R01DetailDto[];
	originalWMS1130_R01DetailList: WMS1130_R01DetailDto[];
	updateWMS1130_R01DetailList: (index: number, data: WMS1130_R01DetailDto) => void;
	gridRef: RefObject<AgGridReact<WMS1130_R01DetailDto> | null>;
	setCodeSearchModalProps: any;
	customCd?: string;
}

export function useWMS1130_R01CellChange({
	WMS1130_R01DetailList,
	originalWMS1130_R01DetailList,
	updateWMS1130_R01DetailList,
	gridRef,
	setCodeSearchModalProps,
	customCd,
}: UseWMS1130_R01CellChangeProps) {
	const { searchExactItemCode } = useCodeSearch({});
	const WMS1130R01Config = createModuleConfig.WMS1130();

		 // PROGRAM 공통코드에서 ITEM_POPUP_SEARCH의 ref01 값으로 필터 사용 여부 결정
		 const { programList } = useCommonCodeStore();
		 const useCustomCdFilter =
			 programList.find(c => c.minorCd === 'ITEM_POPUP_SEARCH')?.ref01 === 'Y';

	const fieldConfigWithSearch = {
		...WMS1130R01Config.fieldConfig,
		codeSearchFields: {
			...WMS1130R01Config.fieldConfig.codeSearchFields,
			itemCd: {
				...WMS1130R01Config.fieldConfig.codeSearchFields!.itemCd,
				searchFilters: () =>
					useCustomCdFilter && customCd?.trim() ? { customCd: customCd.trim() } : undefined,
				searchFunction: searchExactItemCode,
				canOpenModal: (row: WMS1130_R01DetailDto) => !!row?.inserted,
			},
		},
	};

	const WMS1130_FIELD_MAPPING = {
		qtyField: "qty",
		priceField: "cost",
		dcField: "dcAmt",
		amountField: "amt",
		preventNegative: true,
	};

	const calculateAmount = (data: WMS1130_R01DetailDto): WMS1130_R01DetailDto => {
		return calculateDetailAmount(data, WMS1130_FIELD_MAPPING);
	};

	return useCommonDetailTableHandlers<WMS1130_R01DetailDto>({
		detailList: WMS1130_R01DetailList,
		updateDetailList: updateWMS1130_R01DetailList,
		originalDetailList: originalWMS1130_R01DetailList,
		setCodeSearchModalProps,
		gridRef,
		fieldConfig: fieldConfigWithSearch,
		codeSearchConfig: WMS1130R01Config.codeSearchConfig,
		calculateAmount,
	});
}
